import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Checkmark.svg?component
var Checkmark_exports = /* @__PURE__ */ __exportAll({
	default: () => Checkmark_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		fill: "none",
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "M21.4 4.6 10.6 19.4l-8-6.4"
	}, null, -1)])]);
}
var Checkmark_default = { render: render$1 };
//#endregion
export { Checkmark_exports, Checkmark_default as default, render$1 as render };

//# sourceMappingURL=Checkmark.svg_component.js.map